import FormUtils from '../Toolkit/FormUtils'

window.FormUtils = new FormUtils()
